module.exports = __webpack_public_path__ + "img/ExistingUserAnd4.dfda08bc.png";